/**
 * redirect to a new tab/window (depends on device)
 * @param to
 * @note opener is set to null to avoid performance/security problems
 */
export function redirectNewTab(to) {
  const newWindow = window.open(to, '_blank');
  if (!window.navigator.standalone) {
    newWindow.opener = null;
  }
}

/**
 * returns uniqueId by auto-incrementing last one
 * @return { string }
 * @note logic is almost same as lodash `uniqueId`
 */
export function uniqueId() {
  uniqueId.lastId = (uniqueId.lastId ?? 0) + 1;
  return String(uniqueId.lastId);
}

/**
 * Returns value as it is
 * used for convenience with functional approach.
 */
export function asIs(value) {
  return value;
}
